import React from "react";
import SingleJobs from "../../components/jobs";

const JobSection = ({ jobs = [] }) => {
  return (
    <div className="it-blog-area pt-50">
      <div className="container">
        <div className="row">
          {jobs.length > 0 ? (
            jobs.map((job) => (
              <div
                key={job._id}
                className="col-xl-12 col-lg-12 col-md-12 mb-30 wow animate__fadeInUp"
                data-wow-duration=".9s"
                data-wow-delay=".3s"
              >
                <SingleJobs
                  jobtitle={job.title || "Untitled Job"}
                  description={job.jobDescription}
                  experience={
                    job.experience
                      ? `${job.experience} years`
                      : "Experience not specified"
                  }
                  location={job.location || "Location not provided"}
                  postedDate={
                    job.createdAt
                      ? new Date(job.createdAt).toLocaleDateString("en-IN")
                      : "Date not available"
                  }
                  link={
                    job._id ? `/job-application?applicationId=${job._id}` : "#"
                  }
                  hasArrow
                  stateData={job.description}
                />
              </div>
            ))
          ) : (
            <p className="text-center w-full">
              No jobs available at the moment.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default JobSection;
